import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Table, TableLazyLoadEvent } from 'primeng/table';
import { NavigationService } from 'src/app/core/service/navigation.service';
import {
  AppConstant,
  MODULE_NAME,
  PERMISSION,
  RESPONSE_CODE,
  STATUS_TBL,
} from 'src/app/helper/class/app-constant';
import {
  cloneData,
  createSearchTableQuery,
  isArray,
  isEmptyObj,
  isExistsKey,
  replaceBracesWithValues,
} from 'src/app/helper/class/utilityHelper';
import {
  ResponseData,
  tableAction,
  tableBuilder,
  tableButton,
  tableColum,
  tableFilter,
  tblFilterQuery,
  whereField,
} from 'src/app/helper/interface/response';
import { AlertService } from 'src/app/helper/service/alert.service';
import { AuthService } from 'src/app/helper/service/auth.service';
import { ChurchBasicComponent } from 'src/app/modules/church/component/church-basic/church-basic.component';
import { MasterApiService } from 'src/app/modules/master/service/master-api.service';
import { ChildBasicInfoComponent } from 'src/app/shared/feature-modal/child-basic-info/child-basic-info.component';
import { PromotionalInfoComponent } from 'src/app/shared/feature-modal/promotional-info/promotional-info.component';
import { StaffBasicComponent } from 'src/app/shared/feature-modal/staff-basic/staff-basic.component';
import { ModalService } from 'src/app/shared/service/modal.service';
import { page } from '../../../../helper/interface/user';
export interface tagInfo {
  data: any;
  text: string;
}

@Component({
  selector: 'app-table-list',
  templateUrl: './table-list.component.html',
  styleUrls: ['./table-list.component.scss'],
})
export class TableListComponent implements OnInit, AfterViewInit {
  @Input() parentGetList: ((args?: any) => Promise<any>) | any;
  @Input() parenttblAction:
    | ((id: string | number, args?: tableAction, data?: any) => Promise<any>)
    | any;
  @Input() viewAction:
    | ((id: string | number, data?: any, col?: string) => Promise<any>)
    | any;
  @Input() tagInfoAction:
    | ((tagData: tagInfo, data?: any, col?: string) => Promise<any>)
    | any;
  data: any;
  tableLoader: boolean = false;
  @Input() selectable: 'SINGLE' | 'MULTI' | false | undefined = false;
  @Input() selecTablePrimary:null|string = null;
  @Input() maxSelection: number = -1; // -1 means unlimited;
  @Output() onSelect: EventEmitter<any> = new EventEmitter();
  @Input() skipId: Array<string | number> = [];
  @Input() title: any;
  @Input() tbl: any;
  @Input() tableConfig: tableBuilder | null = {} as tableBuilder;
  @Input() globalFilterField: Array<any> = [];
  @Input() exportLoading: boolean = false;
  showFilter: boolean = false;
  cols: Array<any> = [];
  actionBtn: Array<any> = [];
  selectedData: Array<any> = [];
  FORM_SUPPORT_DATA: any = {};
  DATA_LOADING: any = {};
  statusArray: any = STATUS_TBL;
  moduleArray: any = Object.keys(MODULE_NAME);
  actionArray: any = Object.keys(PERMISSION);
  totalRecords: number = 0;
  primaryKey: string | number | any = 'id';
  lastFilter: tblFilterQuery = {} as tblFilterQuery;
  defaultRow = AppConstant.TABLE_PAGE_ROWS;
  first = 0;
  btnLoader: any = {};
  @Input() silentMode: boolean = false;
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @ViewChild('d1') tblDiv: Table = {} as Table;
  yearRange = AppConstant.DEFAULT_DATE_RANGE;
  constructor(
    private alertService: AlertService,
    private modalService: ModalService,
    private masterApi: MasterApiService,
    private navServe: NavigationService,
    private router: Router,
    private activateRoute: ActivatedRoute,
    private ref: ChangeDetectorRef,
    private auth: AuthService
  ) {}
  paramsKeys: any = [];
  allParams: any = {};
  pageParams = {};
  tblInit: boolean = false;

  ngOnInit(): void {
    if (this.tableConfig?.rows) {
      this.defaultRow = this.tableConfig.rows;
    }
    if (!this.silentMode) {
      const params: any = this.activateRoute.snapshot.queryParamMap;
      this.allParams = params['params'] || {};
      const s = this.allParams.page ? JSON.parse(this.allParams.page) : {};
      this.pageParams = s;
      if (s && !isEmptyObj(s)) {
        if (s.rows) {
          this.defaultRow = s.rows;
        }
        if (s.page) {
          this.first = +s.page * this.defaultRow;
        }
      }
    }
    this.initTbl();
    const { isLazy, noApiCall } = this.tableConfig || {};
    if (!isLazy && !noApiCall) {
      this.getData();
    }
  }

  ngAfterViewInit() {
    this.tblInit = true;
  }

  updateFromQueryParams(ev: TableLazyLoadEvent, tbl: Table) {
    return new Promise((resolve) => {
      let filters = {};
      const s: any = this.pageParams;
      if (s?.queryParams && isArray(s?.queryParams)) {
        setTimeout(() => {
          const columns = Object.keys(tbl.filters);
          s?.queryParams.forEach((f) => {
            if (columns.includes(f?.colName)) {
              filters[f?.colName] = f;
              //@ts-ignore
              tbl.filters[f?.colName]['value'] = f?.value;
            }
          });
          ev = { ...ev, filters };
          resolve(ev);
        }, 100);
      } else {
        resolve(ev);
      }
    });
  }

  colObject = {};
  allColObject = {};
  async initTbl() {
    this.cols = [];
    await this.tableConfig?.column.map((a) => {
      if (a.filter && !this.tableConfig?.showFilter) {
        this.showFilter = true; // if any one has filter show filter will be true
      }
      if (a.isPrimary) {
        this.primaryKey = a.selectKeyName ? a.selectKeyName : a.colName;
      }
      if (!('visible' in a)) {
        a.visible = true;
      }

      let colType: tableFilter = {} as tableFilter;
      if (a.filter) {
        colType = a.filterCol ? a.filterCol : ({} as tableFilter);
      }
      switch (a.filterCol?.type) {
        case 'DROPDOWN':
          this.FORM_SUPPORT_DATA[a?.colName] = isArray(a?.filterCol?.data)
            ? a?.filterCol?.data
            : [];
          if (a.filterCol?.apiName) {
            this.getFullData(a);
          }
          break;
      }
      //colJoin
      const colA = {
        field: a.selectKeyName ? a.selectKeyName : a.colName,
        colName: a.colName,
        header: a.title || a.colName,
        type: a.colType,
        sort: a.sort,
        filter: a.filter,
        filterCol: a.filterCol,
        icon_append: a.icon_append || '',
        colJoinSeparator: a?.colJoinSeparator || false,
        colJoinName: a?.colJoinName || '',
        isEditable: a.isEditable,
      };
      this.allColObject[a.colName] = colA;
      if (a.visible) {
        this.colObject[a.colName] = colA;
      }
    });
    this.cols = Object.values(this.colObject);
    this.tableConfig?.action?.map((a: tableButton) => {
      if (a.type) {
        const mName: any = a.permission?.moduleName,
          aName: any = a.permission?.actionName;
        if (!mName) {
          this.actionBtn.push(a);
          return;
        }
        if (isExistsKey(a, ['permission', 'moduleName'])) {
          if (this.auth.checkPermission(mName, aName)) {
            this.actionBtn.push(a);
          }
        }
      }
    });
  }
  syncCol(col: tableColum[]) {
    if(this.tableConfig){
    if(!this.tableConfig?.column){
        this.tableConfig['column'] = [] as tableColum[];
    }
    this.tableConfig.column.map((a) => {
      const c = col.find((b) => b.colName == a.colName);
      a={ ...a, ...c };
    });
    // this.tableConfig.column = col;
  }
    this.initTbl();
  }
  getColWithJoin(cName) {
    const s: any = this.colObject[cName],
      res: any = [];
    if (s.colJoinName) {
      res.push(this.allColObject[s.colJoinName]);
    }
    res.push(s);
    return res;
  }
  makeChange = true;
  markChanged() {
    this.makeChange = false;
    this.setTableData(this.data);
    this.ref.detectChanges();
    this.makeChange = true;
  }

  getFullData(a: tableColum) {
    this.DATA_LOADING[a.colName] = true;
    const api: any = this.masterApi.getFullData(a.filterCol?.apiName || '', []);
    api
      .then((res: ResponseData | any) => {
        if (res.statusCode == RESPONSE_CODE.SUCCESS) {
          this.FORM_SUPPORT_DATA[a.colName] = [];
          if (isArray(res.result)) {
            const aF: any = a?.filterCol?.apiFilter || {};
            if (a.filterCol?.appendData) {
              res.result = [...a.filterCol.appendData, ...res.result];
            }
            if (aF?.keyName) {
              //@ts-ignore
              this.FORM_SUPPORT_DATA[a.colName] = res.result.filter((b: any) =>
                this.checkOperation(
                  b[aF?.keyName],
                  aF?.value,
                  aF?.operation || '=='
                )
              );
            } else {
              this.FORM_SUPPORT_DATA[a.colName] = res.result;
            }
          }
        }
      })
      .finally(() => (this.DATA_LOADING[a.colName] = false));
  }

  checkOperation(val: any, compare: any, operation = '==') {
    val = [null, undefined, ''].includes(val) ? '' : val;
    let result = false;
    switch (operation) {
      case '!=':
        if (Array.isArray(compare)) {
          return (result = !compare.includes(val));
        } else {
          result = val != compare;
        }
        break;
      case '>=':
        result = val >= compare;
        break;
      case '>':
        result = val > compare;
        break;
      case '<':
        result = val < compare;
        break;
      default:
        if (Array.isArray(compare)) {
          return (result = compare.includes(val));
        } else {
          result = val == compare;
        }
        break;
    }
    return result;
  }

  pushHistory(ev: tblFilterQuery) {
    const frg: any = this.activateRoute.snapshot.fragment;
    this.router.navigate([], {
      relativeTo: this.activateRoute,
      queryParams: { page: JSON.stringify(ev) },
      fragment: frg,
      queryParamsHandling: 'merge',
      //skipLocationChange:true
    });
  }
  initialCall = true;
  getWhereField(): whereField[] {
    let whereField: whereField[] = [];
    if (
      this.tableConfig?.whereFieldByModule &&
      !isEmptyObj(this.tableConfig?.whereFieldByModule)
    ) {
      const w = this.tableConfig?.whereFieldByModule;
      whereField = this.auth.getPermittedId(w.mName, w.aName, w?.keys || []);
    }
    return whereField;
  }
  getData(ev: tblFilterQuery = {} as tblFilterQuery) {
    ev.initialCall = this.initialCall;
    this.currentPage = ev.page || 0;
    const frg: any = this.activateRoute.snapshot.queryParams.page || '';
    if (!this.silentMode) {
      if (!this.initialCall || ev.queryParams?.length) {
        this.pushHistory(ev);
      }
    }
    this.tableLoader = true;
    ev.whereField = this.getWhereField();
    ev?.queryParams?.map((a: any) => {
      if (typeof a.value == 'string') {
        a.value = a.value.trim();
      }
      return a;
    });
    this.parentGetList?.(ev)
      .then((res: ResponseData | any) => {
        this.initialCall = false;
        if (res?.statusCode == 200) {
          this.data = res.result.data || res?.result || [];
          if (this.tableConfig?.isLazy) {
            this.markSelectable();
            this.totalRecords = res.result.totalRecord;
          } else {
            this.setTableData(this.data);
          }
          this.ngAfterViewInit();
        } else if (Array.isArray(res)) {
          this.setTableData(res);
        }
      })
      .catch((res: any) => {
        console.log(res, 'Date result');
      })
      .finally(() => {
        this.tableLoader = false;
      });
  }

  setTableData(res: any) {
    this.data = [];
    if (isArray(res)) {
      this.data = res;
      this.totalRecords = this.data.length;
    }
  }

  openStaffInfo(id: string | number, mode = 'STAFF', sData: any = {}) {
    let component: any = StaffBasicComponent;
    const data: any = { mode: mode, staff_emp_id: id };
    switch (mode) {
      case 'CHILD_ID':
        data.child_id = id;
        component = ChildBasicInfoComponent;
        break;
      case 'SPONSOR_ID':
        return this.modalService.openSponsorInfo({
          sponsor_id: sData.sponsor_fk_id || sData.sponsor_id || id,
        });
        break;
      case 'CHURCH_ID':
        data.church_id = id;
        component = ChurchBasicComponent;
        break;
      case 'PROMOTIONAL_ID':
        id = +id ? id : sData.promotional_office || sData.id;
        data.id = id;
        component = PromotionalInfoComponent;
        break;
    }
    this.modalService.openModal(component, data, 'modal-lg');
  }

  async btnAction(
    id: string | number,
    type: tableAction,
    data = {},
    index = null
  ) {
    this.btnLoader = { [index + type]: true };
    const a: tableButton =
      this.tableConfig?.action?.find((a) => a.type == type) ||
      ({} as tableButton);
    if (!isEmptyObj(a?.url) && a.url) {
      this.navServe.navigateByConfig(a.url, data);
      return;
    }
    if (!isEmptyObj(a?.confirmModal) && a.confirmModal) {
      const confirmModal = cloneData(a.confirmModal);
      if (confirmModal.message) {
        confirmModal.message = replaceBracesWithValues(
          confirmModal.message,
          data
        );
      }
      const confirmResult: any = await this.modalService.openConfirmDialog(
        confirmModal
      );
      if (!confirmResult) {
        this.btnLoader = { [index + type]: false };
        return;
      } else {
        data = isEmptyObj(confirmResult) ? data : { ...data, ...confirmResult };
      }
    }
    this.parenttblAction?.(id, type, data).then((res: any) => {
      this.btnLoader = { [index + type]: false };
      if (res.reload) {
        this.reload();
      }
    });
  }

  btnAnchorAction(id: string | number, data = {}, col: string) {
    this.viewAction?.(id, data, col).then((re) => {
      console.log('result of Anchor action', re);
    });
  }

  btnTagInfo(tag: tagInfo, data: any) {
    this.tagInfoAction?.(tag, data);
  }

  reload() {
    if (this.tableConfig?.isLazy) {
      if (!isEmptyObj(this.lastFilter)) {
        this.loadData(this.lastFilter);
      } else {
        this.tblDiv.filter('', this.tableConfig?.column[0].colName, 'contains');
      }
    } else {
      this.getData();
    }
  }

  currentPage:number=0;
  async loadData(ev: any = {}, tbl?: Table) {
    if (!this.tblInit) {
      ev = await this.updateFromQueryParams(ev, tbl as Table);
    }
    if (!isEmptyObj(ev)) {
      this.lastFilter = createSearchTableQuery(ev) || {};
    }
    this.getData(this.lastFilter);
  }

  AddRemoveSelection(con: any) {
    if (this.selectable) {
      let index = this.isExistsData(con);
      if (this.isExistsData(con) == -1) {
        if (
          this.maxSelection == -1 ||
          (this.maxSelection != -1 &&
            this.maxSelection > this.selectedData.length)
        ) {
          this.selectedData.push(con);
        } else {
          this.selectedData.splice(0, 1);
          this.selectedData.push(con);
        }
      } else {
        this.selectedData.splice(index, 1);
      }
      this.markSelectable();
      this.onSelect.emit(this.selectedData);
    } else {
      this.onSelect.emit(con);
    }
  }
  getSelectedData() {
    return this.selectedData;
  }

  clearAllSelection() {
    this.selectedData = [];
    this.markSelectable();
    this.onSelect.emit(this.selectedData);
  }

  markSelectable() {
    if (this.selectable) {
      if (this.selectedData.length) {
        this.data.map((a: any) => {
          console.log(a, ' A value');
          if (this.isExistsData(a) == -1) {
            a.selectable = false;
          } else {
            a.selectable = true;
          }
        });
        console.log(this.data, 'selectable list');
      } else {
        this.data.map((a: any) => (a.selectable = false));
      }
    } else {
      this.selectedData = [];
    }
  }

  updateRow(row: any, field: any, data: any, index: any) {
    // console.log('id',row,'controlName',field,'value',data)
    this.onChangeEvent.emit({
      controlName: field,
      value: data || '',
      row: row,
      index: index,
    });
  }

  onSelectData(con: any) {
    if (this.skipId.includes(con[this.primaryKey])) {
      this.alertService.showToast('Duplicate Selection, unable to select', 'info');
      return;
    }
    this.AddRemoveSelection(con);
  }

  onPageChange(event: any) {
    this.defaultRow = event.rows;
  }

  onclickSpan(d: any) {
    console.log('on clicked span ', d);
  }
  isExistsData(con: any) {
    return this.selectedData.findIndex(
      (a) => a[this.primaryKey] == con[this.primaryKey]
    );
  }
}
